import React from 'react'
import { Form, Select, DatePicker, InputNumber, Input } from 'antd'
import styled from 'styled-components'
import { t } from '@/i18n'
import { FREQUENCY_OPTIONS, WEEKLY_OPTIONS } from '../../utils/constants'

const SchedulerConfig: React.FC = () => (
  <Wrapper>
    <Form.Item
      label={<span style={{ color: '#666' }}>{t('周期配置')}</span>}
      style={{ marginBottom: 0 }}
    >
      <Input.Group compact>
        <Form.Item name="periodType" noStyle>
          <Select style={{ width: 98 }} options={FREQUENCY_OPTIONS} />
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.periodType !== currentValues.periodType
          }
        >
          {({ getFieldValue: getPeriodType }) => {
            const periodType = getPeriodType('periodType')
            if (periodType === 'scheduler_type_weekly') {
              return (
                <Form.Item name={['cronSchedule', 'dayOfWeek']} noStyle>
                  <Select
                    mode="multiple"
                    placeholder={t('选择星期')}
                    style={{ width: 130 }}
                    options={WEEKLY_OPTIONS}
                    maxTagCount={1}
                  />
                </Form.Item>
              )
            }
            if (periodType === 'scheduler_type_monthly') {
              return (
                <Form.Item name={['cronSchedule', 'dayOfMonth']} noStyle>
                  <Select
                    mode="multiple"
                    placeholder={t('选择日期')}
                    style={{ width: 120 }}
                    options={Array.from({ length: 31 }, (_, i) => ({
                      label: `${i + 1}${t('号')}`,
                      value: i + 1,
                    }))}
                    maxTagCount={1}
                  />
                </Form.Item>
              )
            }
            return null
          }}
        </Form.Item>
        <Form.Item name={['cronSchedule', 'timeOfDay']} noStyle>
          <DatePicker.TimePicker
            placeholder={t('选择时间')}
            style={{ width: 200, borderRadius: '0 6px 6px 0' }}
          />
        </Form.Item>
      </Input.Group>
    </Form.Item>
    <div style={{ display: 'flex', alignItems: 'center', marginLeft: 10 }}>
      <Form.Item
        label={<span style={{ color: '#666' }}>{t('总执行次数')}</span>}
        name="executionTimes"
        style={{ marginBottom: 0 }}
      >
        <InputNumber min={1} max={999} placeholder={t('默认不限次数')} style={{ width: 120 }} />
      </Form.Item>
      <span style={{ marginLeft: 8 }}>{t('次')}</span>
    </div>
  </Wrapper>
)

export default SchedulerConfig

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin: 0 0 24px 115px;
`
